import { creatorApi } from '@store';

export const useCreatorApi = () => {
    return { ...creatorApi };
};
